import BigButton from "components/atoms/buttons/BigButton";
import Input from "components/atoms/input/Input";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { useCallback, useState } from "react";
import { PiCheckCircleFill } from "react-icons/pi";
import { COLORS } from "styles/colors";
import Hashtag from "../hashtag/Hashtag";
import Spinner from "components/atoms/loader/Spinner";
import * as s from "components/templates/modal/ModalTemplateStyled";
import * as sr from "./ScreenRecorderVideoShareStyled";
import { uploadRecordedVideoToVideoShare } from "api/screenRecorderAPI";
import { useAuth } from "components/Auth";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { ScreenRecorderHookProps } from "./useScreenRecorder";
import useApiError from "hook/useApiError";
import { checkEmpty, toTrim } from "utils/functions";

interface Props {
  setIsUploadVideoShare: (finish: boolean) => void;
  hookProps: ScreenRecorderHookProps;
  fileName: string;
}

export default function ScreenShareVIdeoShare(props: Props) {
  const auth = useAuth();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [videoTitle, setVideoTitle] = useState<string>("");
  const [tags, setTags] = useState<string[]>([]);
  const { notifySuccess, notifyError, lang } = useApiError();
  const [isVideoShareUploaded, setIsVideoShareUploaded] =
    useState<boolean>(false);
  const [isVideoShareUploading, setIsVideoShareUploading] =
    useState<boolean>(false);
  const { resultBlob: blob, durationInMs, startedAt } = props.hookProps;
  function uploadToVideoShare() {
    if (!blob) {
      return;
    }
    setIsVideoShareUploading(true);

    if (checkEmpty(videoTitle)) {
      return;
    }

    const payload = {
      accountId: selectedAccount.accountId,
      userEmail: auth.user.email,
      title: toTrim(videoTitle),
      fileName: props.fileName,
      startTimeMs: (startedAt || new Date()).valueOf(),
      durationMs: durationInMs,
      description: "This video was recorded on the user's PC.",
      tags: tags,
    };

    uploadRecordedVideoToVideoShare(blob, payload)
      .then((res) => {
        // setVideoId(res.videoId);
        setIsVideoShareUploaded(true);
        notifySuccess(lang.validateMsg.videoShare.err.uploadSuccess);
      })
      .catch((err) => {
        notifyError(lang.validateMsg.videoShare.err.uploadFail);
      })
      .finally(() => {
        setIsVideoShareUploading(false);
      });
  }
  // hashtag 변경 이벤트
  const onChangeHashtag = useCallback(
    (e: any) => {
      // console.log(e, "onChangeHashtag");
      let tempTagsArr: string[] = [];
      var valueArr = e.detail.tagify.value;

      valueArr?.map((val: any) => tempTagsArr.push(val.value));
      setTags(tempTagsArr);
    },
    [tags]
  );
  return (
    <BigPopupTemplate
      title="Upload to Video Share"
      onModal={() =>
        props.setIsUploadVideoShare(isVideoShareUploaded ? true : false)
      }
      disableClose={isVideoShareUploading}
    >
      <sr.ShareUploadContainer>
        <ModalInput essential label="Title">
          <Input
            value={videoTitle}
            onChange={(e) => setVideoTitle(e.target.value)}
            disabled={isVideoShareUploaded || isVideoShareUploading}
            data-testid="blocks-screenrecorder-input-set-video-title"
          />
        </ModalInput>
        <ModalInput label="Tag">
          <Hashtag
            defaultValue={tags.join(",")}
            onChange={onChangeHashtag}
            onKeydown={(e) => {
              console.log(e);
            }}
            disabled={isVideoShareUploaded || isVideoShareUploading}
          />
        </ModalInput>
        {isVideoShareUploading && (
          <sr.ShareUploading>
            <Spinner />
          </sr.ShareUploading>
        )}

        {isVideoShareUploaded && (
          <sr.ShareUploadedSuccess>
            <h3>
              <PiCheckCircleFill color={COLORS.GREEN} size="20px" /> Success
            </h3>
            You can view the recorded video in Video Share.
          </sr.ShareUploadedSuccess>
        )}
      </sr.ShareUploadContainer>
      <s.ButtonWrapper>
        <BigButton
          buttonType="cancel"
          onClickBtn={() =>
            props.setIsUploadVideoShare(isVideoShareUploaded ? true : false)
          }
          disabled={isVideoShareUploading}
          label={isVideoShareUploaded ? "Close" : "Cancel"}
          data-testid="blocks-screenrecorder-button-set-is-upload-video-share"
        />

        {!isVideoShareUploaded && (
          <BigButton
            onClickBtn={() => uploadToVideoShare()}
            label="Upload"
            disabled={checkEmpty(videoTitle) || isVideoShareUploading}
            data-testid="blocks-screenrecorder-button-upload-to-video-share"
          />
        )}
      </s.ButtonWrapper>
    </BigPopupTemplate>
  );
}
